import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from 'src/reducers/RootReducer';
import DocumentContractMiniatureComponent from './DocumentContractMiniature.component';
import { getImage, GetImageAction, GetImageSuccess } from 'src/actions/image/get/GetImage.actions';
import ContractSignedComponent
  from 'src/modules/project/partials/project-formalization/partials/sign-contracts/partials/ContractSigned.component';
import {
  downloadDocument,
  DownloadDocumentAction
} from 'src/actions/project/download-document/DownloadDocument.actions';

interface StateProps {
  image?: File;
}

export interface OwnProps {
  typeDocument: boolean;
  documentFile: string;
  imageFile?: string;
  active: boolean;
  action?: string;
  image?: File;
  handleSubmitDocument?: (typeDocument: boolean) => void;
}

interface DispatchProps {
  getImage: (imageName: string) => Promise<GetImageAction>;
  download: (document: string, id: number, download: boolean) => Promise<DownloadDocumentAction>;
}

interface State {
  documentPreview?: File;
  text: string;
}

interface Props extends StateProps, OwnProps, DispatchProps {
}

class DocumentContractMiniatureContainer extends React.Component<Props, State> {

  public state = {
    text: '',
    documentPreview: undefined
  };

  public componentDidMount(): void {
    if (this.props.imageFile) {
      this.props.getImage(this.props.imageFile).then( (response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({ documentPreview: response.payload });
        }
      });
    }

    if (this.props.typeDocument) {
      this.setState(
        {
          text: 'Acuerdo de sindicación'
        });
    } else {
      this.setState(
        {
          text: 'Pacto de socios'
        });
    }
  }

  public render(): React.ReactNode {
    if (this.props.imageFile && !this.props.image) {
      return null;
    }

    return (
      !this.props.active ?
        (
          <DocumentContractMiniatureComponent
            image={this.state.documentPreview}
            action={this.props.action}
            documentFile={this.props.documentFile}
            handleSubmitDocument={
              this.props.handleSubmitDocument ?
                (typeDocument: boolean) => this.props.handleSubmitDocument!(typeDocument) :
                undefined
            }
            typeDocument={this.props.typeDocument}
            download={() => this.props.download(this.props.documentFile, 1, false)}
          />
        ) :
        <ContractSignedComponent fileName={this.state.text} />
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
    getImage: (imageName: string): Promise<GetImageAction> => {
      return dispatch(getImage(imageName));
    },
    download: (document: string, id: number, download: boolean): Promise<DownloadDocumentAction> => {
      return dispatch(downloadDocument(document, id, download));
    }
  });

const mapStateToProps: (state: RootState, ownProps: OwnProps) => StateProps = (state: RootState):
  StateProps => ({
    image: state.getImage.image,
  });

export default connect(mapStateToProps, mapDispatchToProps)(DocumentContractMiniatureContainer);


// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/sign-contracts/partials/DocumentContractMiniature.container.tsx